import { css, styled } from 'styled-components';

import { StyledInputContainer } from '../common/StyledInputContainer.ts';

export const TextareaWrapper = styled(StyledInputContainer)`
  position: relative;
  max-height: unset;
  display: block;
  box-sizing: border-box;
`;

interface StyledTextareaProps {
  $hasAdornment?: boolean;
}

export const StyledTextarea = styled.textarea<StyledTextareaProps>`
  ${({ theme }) => theme.typography.textMedium}
  box-sizing: border-box;
  display: block;
  resize: none;
  width: 100%;
  height: 100%;
  padding: 8px 12px;
  border: none;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.black_1};

  ${({ $hasAdornment }) =>
    $hasAdornment &&
    css`
      padding-bottom: 18px;
    `}

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey70_1};
  }

  &[disabled] {
    cursor: not-allowed;
    color: ${({ theme }) => theme.colors.grey100_2};

    &::placeholder {
      color: ${({ theme }) => theme.colors.grey100_2};
    }
  }

  &:focus {
    outline: none;
  }
`;

export const BottomAdornment = styled.div`
  position: absolute;
  bottom: 3px;
  right: 3px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  pointer-events: none;
`;

export const LengthCounter = styled.div`
  user-select: none;
  padding: 1px 3px;
  border: 1px solid ${({ theme }) => theme.colors.grey30_1};
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.grey01_1};
  color: ${({ theme }) => theme.colors.grey70_1};
  font-size: 0.75rem;
  text-align: right;
`;
